import { splitWords } from "./split-words.js";
function toCamelCase(str) {
  return splitWords(str ?? "").map(
    (word, i) => i === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join("");
}
export {
  toCamelCase
};
//# sourceMappingURL=to-camel-case.js.map
